(function($){

    var $body           = $('body'),
        triggerContactLi  = $('.contact_menu'),
        triggerContact  = $('.contact_menu a'),
        contactDrawer   = $('.contact_page'),
        closeContact    = $('.close_contact'),
        contactInfo     = $('.contact_info');

    if ( $(window).width() > 768) {
        triggerContactLi.on('click', function(e){
            e.preventDefault();
            contactDrawer.addClass('open');
            $body.css('overflow', 'hidden');
            contactInfo.css('overflow', 'scroll');
            if(ga){
                ga('send', 'event', 'Button', 'Click', 'Contact Slide Out');
            }
        });

        closeContact.on('click', function(){
            contactDrawer.removeClass('open');
            $body.css('overflow', 'visible');
            contactInfo.css('overflow', 'hidden');
        });
    }
})(jQuery);